import { makeStyles } from '@mui/styles';
const COLOR_MANDATORY = '#F01C10';

export const useStyles = makeStyles((theme) => ({
  greyText: {
    color: theme.palette.grey[700],
  },
  allPlansButton: {
    paddingLeft: 0,
    color: theme.palette.grey[600],
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(3),
  },
  paymentDetailsCard: {
    marginTop: theme.spacing(3),
    boxShadow: 'none !important',
  },
  termsText: {
    marginTop: theme.spacing(3),
    color: theme.palette.grey[700],
    lineHeight: theme.typography.subtitle1.lineHeight,
  },
  paymentMethodFormControl: {
    marginBottom: theme.spacing(2),
  },
  paymentOption: {
    '& span': {
      lineHeight: 0,
    },
    '& img': {
      marginRight: theme.spacing(1),
    },
  },
  paymentOptionDisabled: {
    opacity: 0.5,
  },
  paymentMethodSepaForm: {
    marginBottom: theme.spacing(2),
  },
  paymentMethodSepaText: {
    marginBottom: theme.spacing(2),
  },
  addCardButton: {
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(1),
  },
  colorMandatory: {
    color: COLOR_MANDATORY,
  },
  inputCardNumber: {
    position: 'relative',
    '& span': {
      paddingLeft: theme.spacing(0.5),
      color: '#7C7C7C',
      fontSize: 12,
      position: 'absolute',
      top: -6,
      left: 12,
      zIndex: 1,
      backgroundColor: theme.palette.common.white,
    },
    '& span.highlight': {
      color: COLOR_MANDATORY,
      marginLeft: 76,
      paddingLeft: 0,
      paddingRight: 5,
    },
    '& span.highlightDate': {
      color: COLOR_MANDATORY,
      marginLeft: 86,
      paddingLeft: 1,
      paddingRight: 4,
    },
    '& span.highlightCVC': {
      color: COLOR_MANDATORY,
      marginLeft: 29,
      paddingLeft: 1,
      paddingRight: 5,
    },
  },
}));
